import { render, staticRenderFns } from "./WCheckBox.vue?vue&type=template&id=945d3fbc&scoped=true&"
import script from "./WCheckBox.vue?vue&type=script&lang=js&"
export * from "./WCheckBox.vue?vue&type=script&lang=js&"
import style0 from "./WCheckBox.vue?vue&type=style&index=0&id=945d3fbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "945d3fbc",
  null
  
)

export default component.exports